import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {
  CompanyGroupVersionCriteriaDto,
  CompanyGroupVersionDto,
  GroupService,
  RouterService,
  SearchDataProvider,
  SearchResult,
} from '../../../../bonding_shared';
import {TextSearchCriteria} from '../../../../bonding_shared/components/search/model/text-search-criteria';
import {BusinessUtils} from '../../../../bonding_shared/utils/business-utils';

@Component({
  selector: 'limit-group-selector',
  templateUrl: './limit-group-selector.component.pug',
})
export class LimitGroupSelectorComponent implements OnInit {
  @Input() title: string;
  @Input() labelKey: string;
  @Input() pagination = true;
  /**
   * Open selector event emitter
   * The same emitter instance should be injected into this component and the component that opens this selector
   */
  @Input() open: Subject<boolean>;

  /**
   * when fixedSearch = true, search is done by injected, predefined criteria, user cannot modify them
   */
  @Input() fixedSearch = false;

  /**
   * to be able to switch between advanced/basic search mode
   * TODO: advanced search mode not implemented yet
   */
  _searchModeSwitchable = false;

  @Input() set searchModeSwitchable(value: boolean) {
    this._searchModeSwitchable = value;
  }

  get searchModeSwitchable(): boolean {
    return this._searchModeSwitchable;
  }

  @Input() oneResultAutoSelection = false;
  /**
   * If data providers gave one row it is selected by default.
   */
  @Input() autoSelectOne = false;

  /**
   *
   */
  @Input() autoSelectId: number = null;

  /**
   * don't use together with textCriteria param
   */
  @Input() set onlyLastVersion(ol: boolean) {
    this.dataProvider.textSearchCriteria.last = ol;
    this.dataProvider.searchCriteria.criteria.last = ol;
  }

  @Input() set criteria(c: CompanyGroupVersionCriteriaDto) {
    // this.dataProvider.textSearch = false;
    this.dataProvider.searchCriteria.criteria = c;
  }

  @Input() set textSearch(ts: boolean) {
    this.dataProvider.textSearch = ts;
  }
  /**
   * don't use together with onlyLastVersion or onlyActiveVersion param
   */
  @Input() set textCriteria(c: TextSearchCriteria) {
    this.dataProvider.textSearch = true;
    this.dataProvider.textSearchCriteria = c;
  }

  @Output() selectItem = new EventEmitter<CompanyGroupVersionDto>();
  @Output() emptySearchResult = new EventEmitter<boolean>();

  pageSize = 10;

  dataProvider: SearchDataProvider<CompanyGroupVersionCriteriaDto, CompanyGroupVersionDto>;

  constructor(public router: RouterService, private service: GroupService) {
    this.dataProvider = new SearchDataProvider<CompanyGroupVersionCriteriaDto, CompanyGroupVersionDto>(this.service);
    this.dataProvider.searchCriteria = BusinessUtils.createGroupSearchSearchCriteria();
    this.dataProvider.textSearch = true;
  }

  ngOnInit() {
    if (this.autoSelectId) {
      this.pageSize = null; // if autoselect then no paging because it can break autoselect
    }
  }

  onChange(contract: CompanyGroupVersionDto) {
    this.selectItem.emit(contract);
    this.open.next(false);
  }

  searchFinished(result: SearchResult<CompanyGroupVersionDto>) {
    if (result.size < 1) {
      this.emptySearchResult.emit(true);
    } else if (result.size === 1 && this.oneResultAutoSelection) {
      this.selectItem.emit(result.result[0]);
      this.open.next(false);
    }
  }
}
